<template>
  <div class="monitor">
    <div class="p-2 rounded" style="height: 681px;">
        <!-- Header -->
        <div class="row p-1">
          <div class="col-md-4 text-start">
            <div class="btn text-info text-end fs-6 mt-2" style="pointer-events: none;">
                {{message}}
            </div>
          </div>
          <div class="col-md-4">
            <div class="btn fw-bold text-white text-start fs-3" style="pointer-events: none; letter-spacing: 3px;">
                Monitor
            </div>
          </div>
          <div class="col-md-2">
            <div class="">
                <input v-show="auto_refresh" class="btn btn-info fs-6 w-100 mt-2 fa-fade" style="pointer-events: none;" type="text" :value="`Refresh in: ${counter} seconds.`" readonly>
            </div>
          </div>
          <div class="col-md-2">
            <div class="input-group flex-nowrap mt-2">
                <button v-show="!auto_refresh" class="btn btn-kraken fs-6 w-100 me-1 rounded" @click="getActivity">
                    <i class="fa-solid fa-lg fa-refresh" :class="{'fa-spin': gettingActivity}"></i>
                </button>
                <button v-show="!auto_refresh" class="btn btn-kraken fs-6 w-100 me-1 rounded" @click="getActivityFile" title="Download activity as Excel File.">
                    <i class="fa-solid fa-lg fa-file-excel"></i>
                </button>
                <button class="btn fs-6 w-100 rounded" :class="{'btn-kraken': auto_refresh && !gettingActivity , 'btn-dark': !auto_refresh, 'btn-warning': auto_refresh && gettingActivity}" @click="toggleAutoRefresh();">
                    <i class="fa-solid fa-lg fa-tower-broadcast" :class="{'fa-fade': auto_refresh}"></i>
                </button>
            </div>
          </div>
        </div>

        <!-- Controls -->
        <div class="row mt-1 p-2">
            <div class="col-md-4">
                <div class="input-group flex-nowrap">
                    <button class="btn btn-kraken fs-6" style="width: 20%; border-right: solid 4px black;">
                        <i class="fa-solid fa-hourglass-start"></i>
                    </button>
                    <div style="width: 80%;">
                        <input class="btn bg-dark text-info fs-6 w-100 mb-1" type="date" v-model="start.date">
                        <input class="btn bg-dark text-info fs-6 w-100" type="time" v-model="start.time">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="input-group flex-nowrap">
                    <button class="btn btn-kraken fs-6" style="width: 20%; border-right: solid 4px black;" @click="setNow">
                        <i class="fa-solid fa-hourglass-end"></i>
                    </button>
                    <div class="" style="width: 80%;">
                        <input class="btn bg-dark text-info fs-6 w-100 mb-1" type="date"  v-model="end.date">
                        <input class="btn bg-dark text-info fs-6 w-100" type="time" v-model="end.time">
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="input-group flex-nowrap" :class="{'disabled-div': gettingUsers}">
                    <button class="btn btn-kraken fs-6 me-1" style="width: 20%;" @click="getUsers">
                        <i class="fa-solid" :class="{'fa-refresh fa-spin': gettingUsers, 'fa-user': !gettingUsers}"></i>
                    </button>
                    <select class="btn bg-dark text-info fs-6 w-100" v-model="user" @change="getActivity">
                        <option value="user">Select a user...</option>
                        <option v-for="(_user, i) in users" :value="_user" v-bind:key="i">{{_user.name}}</option>
                    </select>
                </div>
                <div class="input-group flex-nowrap mt-1" :class="{'disabled-div': gettingDevices}">
                    <button class="btn btn-kraken fs-6 me-1" style="width: 20%;" @click="getDevices">
                        <i class="fa-solid fa-lg" :class="{'fa-refresh fa-spin': gettingDevices, 'fa-server': !gettingDevices}"></i>
                    </button>
                    <select class="btn bg-dark text-info fs-6 w-100" v-model="device">
                        <option value="device">Select a device...</option>
                        <option v-for="(_device, i) in devices" :value="_device" v-bind:key="i">{{_device.hostname}}</option>
                    </select>
                </div>
            </div>
        </div>

        <!-- Activity Table -->
        <div class="mt-2" :class="{'disabled-div': gettingActivity}">
            <div class="row">
                <div class="col-md-12">
                    <div class="mt-1">
                        <div class="tableFixHead" style="height: 475px;">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="fw-light btn-kraken fs-5" style="border-bottom: solid 1px rgb(0, 14, 86); width: 10px;" title="#">
                                            <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                                        </th>
                                        <th class="fw-light btn-kraken fs-5" style="width: 150px;"  title="Activity Datetime">
                                            <i class="fa-solid fa-lg fa-clock"></i>
                                        </th>
                                        <th class="fw-light btn-kraken fs-5" style="width: 100px;"  title="User">
                                            <i class="fa-solid fa-lg fa-user"></i>
                                        </th>
                                        <th class="fw-light btn-kraken fs-5" style="width: 100px;"  title="Management IP">
                                            <i class="fa-solid fa-lg fa-ethernet"></i>
                                        </th>
                                        <th class="fw-light btn-kraken fs-5" style="width: 100px;"  title="Source IP">
                                            <i class="fa-solid fa-lg fa-circle-nodes"></i>
                                        </th>
                                        <th class="fw-light btn-kraken fs-5" style="border-bottom: solid 1px rgb(0, 14, 86); width: 150px;"  title="Activity">
                                            <i class="fa-solid fa-lg fa-person-walking"></i>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(c, i) in activities" v-bind:key="i+1"> <!-- Content Row -->
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                            <p class="text-white fs-6 mt-1">{{i+1}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                            <p class="text-white fs-6 mt-1">{{c.datetime}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 100px;">
                                            <p class="text-white fs-6 mt-1">{{c.user}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 100px;">
                                            <p class="text-white fs-6 mt-1">{{c.management_ip}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 100px;">
                                            <p class="text-white fs-6 mt-1">{{c.source_ip}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 100px;">
                                            <p class="text-white fs-6 mt-1">{{c.activity}}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
// Import the component with the line below.
//import Monitor from '@/components/Monitor.vue'

// Add this to parent headerbar: @setAppSection="setAppSection($event)"

import axios from "axios";

export default {
  name: 'Monitor',
  components: {},
  data(){
    return {
      // General
      site: null,
      stage: null,
      // Monitor
      now: null,
      today: null,
      message: "Hello",
      // Users
      user: "user",
      users: [],
      gettingUsers: false,
      // Devices
      device: "device",
      devices: [],
      gettingDevices: false,
      // Refresh
      auto_refresh: false,
      ar_id: null, 
      counter: 60,
      // Activities
      gettingActivity: false,
      gettingActivityFile: false,
      activities: [],
      start: {
        date: "2023-01-01",
        time: "00:00"
      },
      end: {
        date: "2023-01-01",
        time: "23:59"
      },
      currentDT: null
    }
  },
  methods:{
    getUsers(){
        this.message = "Updating users..."
        this.user = "user"
        this.users = []
        this.gettingUsers = true
        const params = {}
        const dest = this.site + '/panoptico/monitor/getUsers'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.gettingUsers = false
                this.users = rx.data.data
                this.message = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingUsers = false
                this.message = "..."
        });
    },
    getDevices(){
        this.message = "Updating devices..."
        this.device = "device"
        this.devices = []
        this.gettingDevices = true
        const params = {}
        const dest = this.site + '/panoptico/monitor/getDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.gettingDevices = false
                this.devices = rx.data.data
                this.message = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingDevices = false
                this.message = "..."
        });
    },
    getActivity(){
        this.message = "Updating activity..."
        this.activities = []
        this.gettingActivity = true
        const params = {start: this.start.date + ' ' + this.start.time,
                        end: this.end.date + ' ' + this.end.time,
                        user: this.user.name,
                        device: this.device.ip
                        }
        const dest = this.site + '/panoptico/monitor/getActivity'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.gettingActivity = false
                this.activities = rx.data.data
                this.message = "..."
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingActivity = false
                this.message = "..."
        });
    },
    getActivityFile(){
        if (!confirm('Download current activity as file?')){
            return
        }
        console.log('Download file...')
        this.gettingActivityFile = true
        const params = {start: this.start.date + ' ' + this.start.time,
                        end: this.end.date + ' ' + this.end.time,
                        user: this.user.name,
                        device: this.device.ip
                        }
        const dest = this.site + '/panoptico/monitor/getActivityFile'
        axios
            .get(dest, {params:params, responseType: 'blob'})
            .then(rx => {
                // OK
                this.gettingActivityFile = false
                // Generate Download
                const url = URL.createObjectURL(rx.data);
                const a = document.createElement('a');
                a.style = 'display: none';
                a.href = url;
                a.download = rx.statusText;
                console.log('Download complete: ', rx.statusText)
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            })
            .catch(error => {
                console.log(error)
                this.gettingActivityFile = false
        });
    },
    toggleAutoRefresh(){
        if (this.auto_refresh){
            try {
                clearInterval(this.ar_id)
            } catch (error) {
                alert(error)
            }
        }
        else{
            this.ar_id = setInterval(this.counting, 1000)
            this.counter = 60
        }
        this.auto_refresh = !this.auto_refresh
    },
    counting(){
        this.counter -= 1
        this.currentDatetime()
        this.message = this.currentDT
        if (this.counter == 0){
            //this.setNow()
            this.setPeriod()
            this.getActivity()
            this.counter = 60
        }
    },
    setNow(){
        this.now = new Date();

        // Day
        if (this.now.getDate() < 10){
            var day = '0' + String(this.now.getDate())
        }
        else{
            var day = this.now.getDate()
        }
        // Month
        if (this.now.getMonth()+1 < 10){
            var month = '0' + String(this.now.getMonth()+1)
        }
        else{
            var month = this.now.getMonth()+1
        }
        // Hours and Minutes
        if (this.now.getHours() < 10){
            var h = '0' + String(this.now.getHours())
        }
        else{
            var h = this.now.getHours()
        }

        if (this.now.getMinutes() < 10){
            var m = '0' + String(this.now.getMinutes())
        }
        else{
            var m = this.now.getMinutes()
        }
        // Set variables
        this.today = `${this.now.getFullYear()}-${month}-${day}`
        this.time = `${h}:${m}`
        this.start.date = this.today
        this.end.date = this.today
        this.end.time = this.time
    },
    currentDatetime(){
        var now = new Date();

        // Day
        if (now.getDate() < 10){
            var day = '0' + String(now.getDate())
        }
        else{
            var day = now.getDate()
        }
        // Month
        if (now.getMonth()+1 < 10){
            var month = '0' + String(now.getMonth()+1)
        }
        else{
            var month = now.getMonth()+1
        }
        // Hours
        if (now.getHours() < 10){
            var h = '0' + String(now.getHours())
        }
        else{
            var h = now.getHours()
        }
        // Minutes
        if (now.getMinutes() < 10){
            var m = '0' + String(now.getMinutes())
        }
        else{
            var m = now.getMinutes()
        }
        // Seconds
        if (now.getSeconds() < 10){
            var s = '0' + String(now.getSeconds())
        }
        else{
            var s = now.getSeconds()
        }

        this.currentDT = `${now.getFullYear()}-${month}-${day} ${h}:${m}:${s}`

    },
    setPeriod(delta= -1, units='hours'){
        const params = {
            delta: delta,
            unit: units
        }
        const dest = this.site + '/panoptico/monitor/period'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.message = "..."
                this.start = rx.data.start
                this.end = rx.data.end
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingUsers = false
                this.message = "..."
        });
    },

    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    printObject(_object){
        console.log(JSON.stringify(_object, null, "   "))
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.setPeriod()
    //this.setNow()
    //this.getUsers()
    //this.getDevices()
    //this.getActivity()
  }
}
</script>

<style scoped>

    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
        transition-duration: 0.5s;
    }
    .btn-kraken:hover{
        background-color: rgb(0, 17, 39);
        color: rgb(0, 211, 249);
    }

  .panoptico-input{
    background-color: rgb(0, 14, 86);
    color: white;
    transition-duration: 0.3s;
  }
  .panoptico-input:hover{
    background-color: rgb(0, 23, 137);
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

  /* Table with static header */
  .tableFixHead {
      overflow-y: auto;
      overflow-x: hidden;
    }
  .tableFixHead thead th {
      position: sticky;
      top: 0;
      text-align: center;
      z-index: 1;
  }
  table {
      border-collapse: collapse;
      width: 100%;
  }
  th, td {
      padding: 5px 15px;
  }
  th {
      background: #eee;
  }

</style>
